import React, { memo } from "react";
import styled from "styled-components";
import GroupTitleAndDescription from "./group_title_and_description";

const GroupSettingsContainer = styled.div`
  position: absolute;
  right: 5px;
  top: -70px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 430px;
  overflow: auto;
  padding: 26px 24px 50px;
  border-left: 1px solid #828282;
  height: max-content;
  max-height: calc(100vh - 80px);
  background: #eaeaea;

  ::-webkit-scrollbar {
    width: 0px;
  }
`;

const GroupSettings = () => {
  return (
    <GroupSettingsContainer
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <GroupTitleAndDescription />
    </GroupSettingsContainer>
  );
};

export default memo(GroupSettings);
